import type { ReactNode } from 'react';
import { GoogleMapsLink } from '@/components/map/GoogleMapsLink';
import type { MapsLinkItem } from '../utils/mapsLinks';

interface TextWithMapsLinkProps {
  children: ReactNode;
  mapsLink: MapsLinkItem | null;
}

export function TextWithMapsLink({ children, mapsLink }: TextWithMapsLinkProps) {
  return (
    <>
      {children}
      {mapsLink ? (
        <>
          {' '}
          <GoogleMapsLink
            href={mapsLink.href}
            label={mapsLink.label}
            title={mapsLink.title}
            size="compact"
            className="align-middle"
          />
        </>
      ) : null}
    </>
  );
}
